import React from "react";

import appConstants from "./appConstants";

const Signin = React.lazy(() => import('./Components/Authentication/SignIn/SignIn'));
const ForgotPassword = React.lazy(() => import('./Components/Authentication/ForgotPassword/ForgotPassword'));
const SSOLogin = React.lazy(() =>
	import('./Components/Authentication/SSOLogin/SSOLogin')
);

const AuthenticationRoutes = 
[
	{ path: "/login", exact: true, name: "Signin", component: Signin },
	{ path: "/oauth-login", exact: true, name: "MyVIE OAuth Login", component: SSOLogin },
	{ path: "/" + appConstants.FORGOT_PASSWORD_SCREEN, exact: false, name: "Forgot Password", component: ForgotPassword }
];

export default AuthenticationRoutes;
